import React, {useState, useContext} from 'react'
import {MainContext} from '../../App';
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  IconButton,
  Card
} from '@material-ui/core';
import {
  Visibility,
  VisibilityOff,
} from '@material-ui/icons';
import {utils} from '../../Helpers/auth';
// import { fetch as __fetch, logonFn } from '../../Helpers/auth';
import { logonFn } from '../../Helpers/auth';
import history from '../../history';
import styled from 'styled-components';
import { logoffFn } from '../../Helpers/auth';


const Card_ = styled(Card)`
  width: 300px;
  /* margin-top: 100px; */
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export default function Logon() {
  const { user:userCtx, setUser:setCtxUser, setNotification } = useContext(MainContext)
  const [ user, setUser ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ showPassword, setShowPassword ] = useState('');
  function toggleShowPassword () {
    setShowPassword(val => !val)
  }

  function handleSubmit (e) {
    e.preventDefault();
    return logonFn({ user, password })
      .then(r => {
        setCtxUser(utils.getPayloadFromToken());
        setNotification({
          type: "success",
          message: `Usuário autenticado com sucesso!`,
          duration: 2000
        })
        // setTimeout(() => history.push("/"), 2000);
        history.push("/");
      })
      .catch(err => {
        console.error(err);
        setNotification({
          type: "error",
          message: "Falha na autenticação"
        })
      })
  }

  if (userCtx) {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}>
        Você está autenticado como <b>{userCtx.alias}</b> <br />
        Deseja trocar de usuário ou reautenticar?
        <Button 
          variant="outlined"
          onClick={() => {
            logoffFn().then(r => {
              setCtxUser()
              history.push("/logon")
            })
        }}>
          Clique aqui
        </Button>
      </div>
    )
  }

  return (
    <form onSubmit={handleSubmit} style={{
      // background: "#C0C0C0",
      padding: '30px',
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <Card_ variant="outlined" elevation="2">
      <div style={{fontSize: '20px'}}>
        <b>Autenticação</b>
      </div>
      <div>
      <TextField
        style={{ width: "240px"}}
        label="Usuário"
        value={user}
        onChange={e => setUser(e.target.value)}
      />
      </div>
      <div>
        <FormControl 
          style={{ width: "240px"}}
        >
          <InputLabel htmlFor="adornment-password">Senha</InputLabel>
          <Input
            id="adornment-password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={e => setPassword(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="Toggle password visibility" onClick={toggleShowPassword}>
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </div>
      <div style={{marginTop: '30px '}}>
      <Button 
        type="submit"
        onClick={handleSubmit}
        variant="outlined"
      >
        Logon
      </Button>
      </div>
      </Card_>
    </form>
  )
}
